module.exports = __webpack_public_path__ + "static/media/project-icon.259bc550.svg";